import Component from 'vue-class-component';
import { WpTariffItem } from '../../components';

@Component({
    template: require("./vdnh-tariff-item.html")
})
export default class GumTariffItem extends WpTariffItem { };